import { render, staticRenderFns } from "./clubs.vue?vue&type=template&id=51bdab5f"
import script from "./clubs.vue?vue&type=script&lang=js"
export * from "./clubs.vue?vue&type=script&lang=js"
import style0 from "./clubs.vue?vue&type=style&index=0&id=51bdab5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports